const cardData = {
  management: [
    {
      section: "Management",
      cards: [
        {
          title: "Initiation",
          text: "I have a patient looking to initiate treatment.",
          category: "management_initiation",
          target: "",
          buttonTitle: "Start Algorithm",
        },
        {
          title: "Pain Management",
          text:
            "My patient is currently experiencing pain and is on medication for opioid use disorder.",
          category: "management_pain",
          target: "",
          buttonTitle: "Start Algorithm",
        },
      ],
      post_content: [
        {
          "style": "plain",
          "visible": "true",
          "text": [
            "<small>The following algorithms are intended for use in the treatment of non-pregnant adults patients.<br></small>",
            "<small>Information on the treatment of pregnant patients and adolescents can be access through the ASAM National Practice guidelines <a href='https://sitefinitystorage.blob.core.windows.net/sitefinity-production-blobs/docs/default-source/guidelines/npg-jam-supplement.pdf?sfvrsn=a00a52c2_2#page=52'' style='text-decoration:none;'>&#9432</a>.</small>"
          ]
        }
      ]
    },
  ],
  tools: [
    {
      section: "Clinical Tools",
      cards: [
        {
          title: "Opioid Addiction DSM-5 Diagnosis",
          text:
            "The DSM-5 guidelines for the diagnosis of opioid use disorder require that the individual has a significant impairment or distress related to opioid use.",
          category: "dsm_oud",
          target: "",
          buttonTitle: "Start tool",
        },
        {
          title: "Clinical Opiate Withdrawal",
          text:
            "The Clinical Opiate Withdrawal Scale (COWS) is an 11-item scale designed to measure the severity of opioid withdrawal signs and symptoms.",
          category: "cows_tool",
          target: "",
          buttonTitle: "Start tool",
        },
        {
          title: "AUDIT-C for Alcohol Use",
          text:
            "The Alcohol Use Disorders Identification Test (AUDIT-C) detects risky drinking patterns in individuals.",
          category: "audit_c",
          target: "",
          buttonTitle: "Start tool",
        },
      ],
    },
    {
      section: "Clinical Algorithms",
      subtitle: "These clinical algorithms are meant to help inform clinicians regarding the use of medications for opioid and alcohol use disorder in the office based addiction treatment setting. They are not meant to replace clinical-decision making.",
      cards: [
        {
          title: "Buprenorphine Quick Start",
          text: "Pathways for starting patients on buprenorphine with various levels of opioid dependence: those not currently opioid dependent, those opioid dependent in active withdrawal, and those at both high and low risk for precipitated withdrawal.",
          pdf: "QSG_2022",
          target: "_blank",
          buttonTitle: "View",
        },
        {
          title: "Initiation of Monthly Injectable Buprenorphine (Sublocade)",
          text: "Guidance for starting a patient on monthly injectable buprenorphine, including required preparation and injection day planning.",
          pdf: "Initiation of Monthly Injectionable Buprenorphine  SLIDE 08-22_FINAL",
          target: "_blank",
          buttonTitle: "View",
        },
        {
          title: "Naltrexone Initiation for Alcohol Use Disorder",
          text: "Guidance for starting a patient on long-acting injectable naltrexone (Vivitrol) for the treatment of alcohol use disorder.",
          pdf: "Naltrexone Initiation for Alcohol Use Disorder SLIDE 09-22_ FINAL",
          target: "_blank",
          buttonTitle: "View",
        },
        {
          title: "Naltrexone Initiation for Opioid Use Disorder",
          text: "Guidance for starting a patient on long-acting injectable naltrexone (Vivitrol) for the treatment of opioid use disorder. Includes strategies for managing opioid withdrawal during washout period and avoiding precipitated withdrawal.",
          pdf: "naltrexone-initiation-for-opioid-use-disorder 09-22_FINAL",
          target: "_blank",
          buttonTitle: "View",
        },
        {
          title:
            "Pain Management While on Buprenorphine for Opioid Use Disorder",
          text: "Guidance for managing acute and chronic pain in patients already on buprenorphine for opioid use disorder.",
          pdf:
            "Pain Management While on Buprenorphine for Opioid Use Disorder 08-22_FINAL",
          target: "_blank",
          buttonTitle: "View",
        },
        {
          title: "Pain Management While on Naltrexone",
          text: "Guidance for managing acute (both anticipated and unanticipated) and chronic pain in patients already on naltrexone.",
          pdf: "Pain Management While on Naltrexone for Opioid Use Disorder 1-25-2023",
          target: "_blank",
          buttonTitle: "View",
        },
        {
          title: "Medications to Assist in the Management of Opioid Withdrawal Symptoms",
          text: "List of medication classes to manage common symptoms of opioid withdrawal.",
          category: "medications_assist",
          target: "",
          buttonTitle: "View",
        },
        {
          title: "Reference for BMC Grayken Center for Addiction TTA",
          text: "",
          category: "references",
          target: "",
          buttonTitle: "View",
        }
      ],
    },
  ],
  resources: [
    {
      section: "Guidelines",
      cards: [
        {
          "title": "2021 Boston Medical Center OBAT Clinical Guidelines",
          "pdf": "22_2021_Clinical_Guidelines_7.29.2021_fp",
          "text": "A detailed guideline of the Nurse Care Manager Model of Office Based Addiction Treatment for health care providers in primary, ambulatory care, behavioral health, corrections, or other practice settings.",
          "target": "_blank",
          "buttonTitle": "Read",
        },
        {
          "title": "Buprenorphine (Bup) Emergency Department Quick Start",
          "href": "https://cabridge.org/tools/on-shift/",
          "text": "Treat patients with opioid use disorder on-shift.",
          category: "",
          target: "_blank",
          buttonTitle: "cabridge.org",
        },
        {
          title:
            "American Society of Addiction Medicine (ASAM) National Practice Guideline for the Treatment of Opioid Use Disorder",
          text:
            "Comprehensive guidelines with recommendations for the evaluation and treatment of OUD, opioid withdrawal, psychosocial treatment, special populations, and opioid overdose.",
          category: "",
          href:
            "https://www.asam.org/Quality-Science/quality/2020-national-practice-guideline",
          target: "_blank",
          buttonTitle: "asam.org",
        },
        {
          title: "CDC Clinical Practice Guideline for Prescribing Opioids for Pain",
          text:
            "Provides recommendations for improving communication between providers and patients about opioid therapy for chronic pain, improving the safety and effectiveness of pain treatment, and reducing risks associated with long-term opioid therapy.",
          category: "",
          href: "https://www.cdc.gov/mmwr/volumes/71/rr/rr7103a1.htm",
          target: "_blank",
          buttonTitle: "cdc.gov",
        },
        {
          title:
            "National Council MAT for Opioid Use Disorder in Jails and Prisons: A Planning and Implementation Toolkit",
          text:
            "Geared towards correctional administrators and health care providers, this toolkit provides resources for the implementation of medications for OUD in correctional settings.",
          category: "",
          href:
            "https://www.thenationalcouncil.org/medication-assisted-treatment-for-opioid-use-disorder-in-jails-and-prisons/",
          target: "_blank",
          buttonTitle: "thenationalcouncil.org",
        },
        {
          title:
            "SAMHSA Clinical Guidance for Treating Pregnant and Parenting Women with Opioid Use Disorder and Their Infants",
          text:
            "Provides comprehensive, national guidance for the management of pregnant and parenting women with OUD and their infants.",
          category: "",
          href:
            "https://store.samhsa.gov/product/Clinical-Guidance-for-Treating-Pregnant-and-Parenting-Women-With-Opioid-Use-Disorder-and-Their-Infants/SMA18-5054",
          target: "_blank",
          buttonTitle: "samhsa.gov",
        },
        {
          title: "SAMHSA Opioid Overdose Prevention Toolkit",
          text:
            "A SAMHSA publication offering strategies to develop practices and policies to prevent opioid-related overdoses and deaths for healthcare providers, communities, and local governments.",
          category: "",
          href: "https://store.samhsa.gov/product/Opioid-Overdose-Prevention-Toolkit/SMA18-4742",
          target: "_blank",
          buttonTitle: "samhsa.gov",
        },
        {
          title:
            "SAMHSA TIP 42- Substance Use Treatment for Persons With Co-Occurring Disorders",
          text:
            "Offers evidence-based recommendations for the screening, assessment, diagnosis, and management of co-occurring substance use and behavioral health disorders.",
          category: "",
          href:
            "https://store.samhsa.gov/product/tip-42-substance-use-treatment-persons-co-occurring-disorders/PEP20-02-01-004",
          target: "_blank",
          buttonTitle: "samhsa.gov",
        },
        {
          title: "SAMHSA TIP 63- Medications for Opioid Use Disorder",
          text:
            "Reviews the use of methadone, naltrexone, and buprenorphine for OUD, as well as other strategies and services needed to support recovery.",
          category: "",
          href:
            "https://store.samhsa.gov/product/TIP-63-Medications-for-Opioid-Use-Disorder-Full-Document/PEP20-02-01-006",
          target: "_blank",
          buttonTitle: "samhsa.gov",
        }
      ],
    },
    {
      section: "Patient Handouts",
      cards: [
        {
          title:
            "Buprenorphine Initiation Guide - English",
          "text": "A guide for patients who are starting buprenorphine in the home or community setting.",
          target: "_blank",
          buttonTitle: "Read",
          pdf: "English V Grayken Colors 121_118_Home_Buprenorphine_Initiation_NIDA_ 09-2022_FINAL",
        },
        {
          title:
            "Buprenorphine Initiation Guide - Spanish",
          "text": "A guide for patients who are starting buprenorphine in the home or community setting.",
          target: "_blank",
          buttonTitle: "Read",
          pdf:
            "Spanish V Grayken Colors 121_118_Home_Buprenorphine_Initiation_NIDA_ 09-2022_FINAL",
        },
      ],
    },
    {
      section: "Web Resources",
      cards: [
        {
          "title": "BMC Grayken Center for Addiction TTA",
          "href": "https://www.addictiontraining.org/",
          "text": "Provides continuing education, organization-specific technical support, and capacity building to community health centers and other health care and social services providers on best practices in caring for patients with substance use disorders.",
          category: "",
          target: "_blank",
          buttonTitle: "addictiontraining.org"
        },
        {
          title: "Center for Excellence for Protected Health Information",
          text: "Educational resources, training, and technical assistance regarding patient confidentiality and interpretation of relevant federal privacy laws and regulations.",
          category: "",
          href: "https://caiglobal.org/index.php?option=com_content&view=article&id=1149&Itemid=1953",
          target: "_blank",
          buttonTitle: "caiglobal.org",
        },
        {
          "title": "Drug Enforcement Administration (DEA)",
          "href": "https://www.dea.gov/drug-information",
          "text": "The DEA carefully monitors and regulates the prescribing of pharmaceutical controlled substances to ensure they are administered and dispensed for legitimate medical purposes in accordance with federal and state laws.",
          category: "",
          target: "_blank",
          buttonTitle: "dea.gov"
        },
        {
          title: "Harm Reduction Coalition",
          text:
            "Publications, online training institute, and multimedia resources to advance harm reduction policies, practices, and programs.",
          category: "",
          href: "https://harmreduction.org/our-resources/",
          target: "_blank",
          buttonTitle: "harmreduction.org",
        },
        {
          title: "Legal Action Center",
          text: "Direct legal services, impact litigation, policy advocacy, education and training, and coalition building to build health equity and restore opportunity for people with substance use disorders, criminal records, and HIV/AIDS.",
          category: "",
          href: "https://www.lac.org/",
          target: "_blank",
          buttonTitle: "lac.org",
        },
        {
          title: "National Substance Use Warmline",
          text: "A National Clinician Consultation Center (NCCC) resource providing free and confidential consultation on substance use evaluation and management for clinicians across the U.S. Hours: Monday-Friday, 9 AM - 8 PM ET.",
          category: "",
          href: "https://nccc.ucsf.edu/clinical-resources/substance-use-resources/",
          target: "_blank",
          buttonTitle: "nccc.ucsf.edu",
        },
        {
          title: "Providers Clinical Support System (PCSS) Discussion Forum",
          text: "Providers Clinical Support System (PCSS) Discussion Forum: An online discussion forum (for educational purposes only) moderated by addiction specialists where health professionals can post questions and receive answers from clinical experts and other colleagues.",
          category: "",
          href: "https://pcssnow.org/mentoring/#forum",
          target: "_blank",
          buttonTitle: "pcssnow.org",
        },
        {
          title: "Scope of Pain",
          text:
            "A series of continuing medical and nursing education activities designed to help providers effectively manage patients with chronic pain, and when appropriate, with opioid analgesics.",
          category: "",
          href: "https://www.scopeofpain.org",
          target: "_blank",
          buttonTitle: "scopeofpain.org",
        }
      ],
    },
  ],
  organizations: [
    {
      section: "Organizations",
      cards: [
        {
          "title": "American Academy of Addiction Psychiatry (AAAP)",
          "href": "https://www.aaap.org/education/resources/",
          "text": "",
          category: "",
          target: "_blank",
          buttonTitle: "aaap.org"
        },
        {
          "title": "American Association for the Treatment of Opioid Dependence (AATOD)",
          "href": "http://www.aatod.org/opioid-education/",
          "text": "",
          category: "",
          target: "_blank",
          buttonTitle: "aatod.org"
        },
        {
          "title": "American Society of Addiction Medicine (ASAM)",
          "href": "https://www.asam.org/education/",
          "text": "",
          category: "",
          target: "_blank",
          buttonTitle: "asam.org"
        },
        {
          "title": "Association for Multidisciplinary Education and Research in Substance use and Addiction (AMERSA)",
          "href": "https://amersa.org/resources/educational-resources/",
          "text": "",
          category: "",
          target: "_blank",
          buttonTitle: "amersa.org"
        },
        {
          "title": "National Institute on Alcohol Abuse and Alcoholism (NIAAA)",
          "href": "https://www.niaaa.nih.gov/health-professionals-communities",
          "text": "",
          category: "",
          target: "_blank",
          buttonTitle: "niaaa.nih.gov"
        },
        {
          "title": "National Institute on Drug Abuse (NIDA)",
          "href": "https://www.drugabuse.gov/nidamed-medical-health-professionals",
          "text": "",
          category: "",
          target: "_blank",
          buttonTitle: "drugabuse.gov"
        },
        {
          title: "Providers Clinical Support System (PCSS)",
          text: "",
          category: "",
          href: "https://pcssnow.org/mentoring/#forum",
          target: "_blank",
          buttonTitle: "pcssnow.org",
        },
        {
          "title": "Substance Abuse and Mental Health Services Administration (SAMHSA)",
          "href": "https://www.samhsa.gov/practitioner-training",
          "text": "",
          category: "",
          target: "_blank",
          buttonTitle: "samhsa.gov",
        }
      ]
    }
  ]
};

export function getCardData() {
  return cardData;
}

export default cardData;
